import { Building2 } from "lucide-react";
import { cn } from "@/lib/utils";

/** A legacy's picture, or the building icon it falls back to. */
export function LegacyMark({
  imageUrl,
  name,
  className,
}: {
  imageUrl?: string | null;
  name: string;
  className?: string;
}) {
  return imageUrl ? (
    <img
      src={imageUrl}
      alt=""
      className={cn("bg-muted size-12 shrink-0 rounded-md object-cover", className)}
      title={name}
    />
  ) : (
    <div
      className={cn(
        "bg-muted text-muted-foreground flex size-12 shrink-0 items-center justify-center rounded-md",
        className
      )}
    >
      <Building2 className="size-1/2" strokeWidth={1.5} />
    </div>
  );
}
